import { NavLink, Outlet } from 'react-router-dom';
import { AssistantPanel } from './AssistantPanel';
import './AppShell.css';

const tabs = [
  { to: '/', label: 'Vault', end: true },
  { to: '/messages', label: 'Messages', end: false },
  { to: '/record', label: 'Record', end: false },
  { to: '/guardians', label: 'Guardians', end: false },
  { to: '/you', label: 'You', end: false },
];

export function AppShell() {
  return (
    <div className="shell">
      <nav className="tabbar" aria-label="Primary">
        {tabs.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end} className={({ isActive }) => (isActive ? 'active' : '')}>
            {t.label}
          </NavLink>
        ))}
      </nav>
      <main className="shell__main">
        <Outlet />
      </main>
      <AssistantPanel />
    </div>
  );
}
